// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"737":"b2af9ec5","3134":"0433b1fb","3837":"a3d0c264","4774":"4eed9b68","9218":"8b22dded"}[chunkId] + ".chunk.css";
};